import React, { useState, useEffect } from "react";

import "./styles.scss";
import { IServiceCategory } from "app/api/types";

interface IProps {
  onSubmit: (data: IServiceCategory) => void;
  onSuccessChange: (active: boolean) => void;
  isSubmit: boolean;
}

const AddService: React.FC<IProps> = ({
  onSubmit,
  onSuccessChange,
  isSubmit
}) => {
  const [title, setTitle] = useState("");

  const onChange = (e: any) => {
    e.target.name === "title" && setTitle(e.target.value);
  };

  const handleSubmit = (e: any) => {
    e.preventDefault();
    onSubmit({
      title,
      href: "service-category"
    });
  };

  const getHeight = () => {
    let height = 50;

    return height;
  };

  useEffect(() => {
    if (title.length > 1) onSuccessChange(true);
    else onSuccessChange(false);

    isSubmit &&
      onSubmit({
        title,
        href: "service-category"
      });
  }, [title, onSuccessChange, onSubmit, isSubmit]);

  return (
    <div className="add-phrase" style={{ height: `${getHeight()}px` }}>
      <form className="add-phrase__form" onSubmit={handleSubmit}>
        <input
          className="add-phrase__input"
          onChange={onChange}
          value={title}
          name="title"
          placeholder="Название"
          autoComplete="off"
          required
        />
      </form>
    </div>
  );
};

export default AddService;
